import { z } from 'zod';
/**
 * 整合提供者枚舉
 */
export const IntegrationProviderSchema = z.enum([
    'line_pay',
    'line_oa',
    'line_messaging',
    'web_widget',
    'fb_ig',
    'telegram',
    'ecpay_payment',
    'ecpay_invoice',
    'ecpay_logistics',
]);
/**
 * LINE Pay 整合設定
 */
export const LinePayIntegrationConfigSchema = z
    .object({
    channel_id: z.string().nullable().optional(),
    channel_secret_encrypted: z.string().nullable().optional(),
    api_base: z.string().nullable().optional(),
    return_url: z.string().nullable().optional(),
    cancel_url: z.string().nullable().optional(),
    verified: z.number().int().min(0).max(1).optional(),
})
    .passthrough();
/**
 * LINE Official Account 整合設定
 */
export const LineOAIntegrationConfigSchema = z
    .object({
    basic_id: z.string().nullable().optional(),
    channel_id: z.string().nullable().optional(),
    channel_secret_encrypted: z.string().nullable().optional(),
    verified: z.number().int().min(0).max(1).optional(),
})
    .passthrough();
/**
 * LINE Messaging API 整合設定
 */
export const LineMessagingIntegrationConfigSchema = z
    .object({
    channel_id: z.string().nullable().optional(),
    channel_secret_encrypted: z.string().nullable().optional(),
    access_token_encrypted: z.string().nullable().optional(),
    verified: z.number().int().min(0).max(1).optional(),
})
    .passthrough();
/**
 * Web Widget 整合設定
 */
export const WebWidgetIntegrationConfigSchema = z
    .object({
    api_key: z.string().nullable().optional(),
    secret_encrypted: z.string().nullable().optional(),
    domain: z.string().nullable().optional(),
    verified: z.number().int().min(0).max(1).optional(),
})
    .passthrough();
/**
 * FB/IG 整合設定
 */
export const FbIgIntegrationConfigSchema = z
    .object({
    app_id: z.string().nullable().optional(),
    app_secret_encrypted: z.string().nullable().optional(),
    page_access_token_encrypted: z.string().nullable().optional(),
    page_id: z.string().nullable().optional(),
    verified: z.number().int().min(0).max(1).optional(),
})
    .passthrough();
/**
 * Telegram 整合設定
 */
export const TelegramIntegrationConfigSchema = z
    .object({
    bot_token_encrypted: z.string().nullable().optional(),
    bot_username: z.string().nullable().optional(),
    webhook_url: z.string().nullable().optional(),
    verified: z.number().int().min(0).max(1).optional(),
})
    .passthrough();
/** 綠界金流 ChoosePayment 單一方式（與綠界文件一致） */
export const ECPAY_CHOOSE_PAYMENT_VALUES = [
    'ApplePay',
    'LinePay',
    'TWQR',
    'GooglePay',
    'Credit',
    'ATM',
    'CVS',
    'BARCODE',
];
export const EcPayChoosePaymentSchema = z.enum(ECPAY_CHOOSE_PAYMENT_VALUES);
/**
 * 綠界金流整合設定
 */
export const EcPayPaymentIntegrationConfigSchema = z
    .object({
    merchant_id: z.string().nullable().optional(),
    hash_key_encrypted: z.string().nullable().optional(),
    hash_iv_encrypted: z.string().nullable().optional(),
    api_base: z.string().nullable().optional(),
    return_url: z.string().nullable().optional(),
    order_result_url: z.string().nullable().optional(),
    /** 啟用的付款方式清單（結帳頁僅顯示此清單內按鈕）；空或未設則等同 ALL */
    ecpay_choose_payment: z.array(z.string()).optional(),
    verified: z.number().int().min(0).max(1).optional(),
})
    .passthrough();
/**
 * 綠界發票整合設定
 */
export const EcPayInvoiceIntegrationConfigSchema = z
    .object({
    merchant_id: z.string().nullable().optional(),
    hash_key_encrypted: z.string().nullable().optional(),
    hash_iv_encrypted: z.string().nullable().optional(),
    api_base: z.string().nullable().optional(),
    verified: z.number().int().min(0).max(1).optional(),
})
    .passthrough();
/** 綠界物流／取貨可啟用選項：超商品牌 + 宅配 */
export const DELIVERY_METHODS_ENABLED_VALUES = [
    '7-ELEVEN',
    'FamilyMart',
    'OK_MART',
    'HiLife',
    'HOME_DELIVERY',
];
export const DeliveryMethodEnabledSchema = z.enum(DELIVERY_METHODS_ENABLED_VALUES);
/**
 * 綠界物流整合設定
 */
export const EcPayLogisticsIntegrationConfigSchema = z
    .object({
    merchant_id: z.string().nullable().optional(),
    hash_key_encrypted: z.string().nullable().optional(),
    hash_iv_encrypted: z.string().nullable().optional(),
    api_base: z.string().nullable().optional(),
    server_reply_url: z.string().nullable().optional(),
    /** 啟用的取貨／物流方式（結帳頁僅顯示此清單內門市按鈕與宅配）；空或未設則全部顯示 */
    delivery_methods_enabled: z.array(z.string()).optional(),
    verified: z.number().int().min(0).max(1).optional(),
})
    .passthrough();
/**
 * 整合設定聯合類型（根據 provider 不同會有不同結構）
 */
export const TenantIntegrationConfigSchema = z.union([
    LinePayIntegrationConfigSchema,
    LineOAIntegrationConfigSchema,
    LineMessagingIntegrationConfigSchema,
    WebWidgetIntegrationConfigSchema,
    FbIgIntegrationConfigSchema,
    TelegramIntegrationConfigSchema,
    EcPayPaymentIntegrationConfigSchema,
    EcPayInvoiceIntegrationConfigSchema,
    EcPayLogisticsIntegrationConfigSchema,
]);
